import { SuccessPageAction } from '../actions/SuccessPageAction'

const initState = {
    qrCodeResponse: {},
    emailServiceResponse: {},
    customerDetailsResponse: {},
}

const SuccessPageReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;

    switch (type) {
        case SuccessPageAction.QR_CODE_SUCCESS:
            return { ...state, qrCodeResponse: payload };

        case SuccessPageAction.EMAIL_SERVICE_SUCCESS:
            return { ...state, emailServiceResponse: payload };

        case SuccessPageAction.GET_CUSTOMER_DETAILS_SUCCESS:
            return { ...state, customerDetailsResponse: payload };

            default:
            return state;
    }

}

export default SuccessPageReducer;